import { render, staticRenderFns } from "./InvoiceCustomApprovalStatusesIndex.vue?vue&type=template&id=aa40956c&scoped=true&"
import script from "./InvoiceCustomApprovalStatusesIndex.vue?vue&type=script&lang=js&"
export * from "./InvoiceCustomApprovalStatusesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa40956c",
  null
  
)

export default component.exports